(function () {
  "use strict";
  /* The snippet is rendered by both the drawer and the cart page, so this file
     can be executed twice on /cart. Two live instances race sync() and each adds
     the reward line once — one guard, one instance. */
  if (window.__bdKitActive) return;
  window.__bdKitActive = true;
  var cfgEl = document.getElementById("bd-kit-config");
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.tiers || !CFG.tiers.length) return;

  /* CURRENCY GUARD (23 Oct 2026, NZ customer: bar said "unlocked", checkout charged for socks).
     The reward discounts' minimums are set in the shop currency (AUD) and Shopify judges them
     on the AUD-equivalent of the cart. The tier thresholds below are AUD cents, but the cart
     total arrives in the customer's currency, so an NZD cart "unlocked" a tier ~20% early.
     Scale the tiers by the market rate for any currency weaker than AUD. The 1.06 buffer covers
     NZ's per-product price adjustments (NZD prices run 1.20x to 1.32x of AUD, the market rate
     alone is 1.257), so the bar can only ever say "unlocked" late, never early. AUD and any
     stronger currency: rate <= 1, tiers untouched, behaviour identical to before. */
  var BD_RATE = 1;
  try { BD_RATE = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
  if (BD_RATE > 1) {
    CFG.tiers.forEach(function (t) { t.threshold = Math.ceil((t.threshold * BD_RATE * 1.06) / 100) * 100; });
  }

  var preview = false;
  try {
    var qs = location.search || "";
    if (qs.indexOf("bdkit=1") >= 0) sessionStorage.setItem("bdkit_preview", "1");
    if (qs.indexOf("bdkit=0") >= 0) sessionStorage.removeItem("bdkit_preview");
    preview = sessionStorage.getItem("bdkit_preview") === "1";
  } catch (e) {}
  if (!CFG.live && !preview) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/",
    OPTOUT = "bdkit_declined",
    addCount = 0,
    lastSig = "";

  /* BD 30 Oct 2026: every write goes through the cart core (bd-cart-core.js): ONE queue, one request in
     flight, and the whole read-decide-write below runs as a single queue job so a reward can never be
     added twice, orphaned, or decided from a stale copy. Fallback keeps the old direct behaviour. */
  var Core = window.BDCart || {
    exclusive: function (fn) { return Promise.resolve().then(function () { return fn(window.fetch.bind(window)); }); },
    idle: function () { return Promise.resolve(); }, hold: function () { return function () {}; },
    isBusy: function () { return false; }, morphInto: null
  };

  function getCart(f) {
    return (f || window.fetch.bind(window))(root + "cart.js?_=" + Date.now(), { headers: { Accept: "application/json" }, cache: "no-store" })
      .then(function (r) { return r.json(); });
  }

  function addLine(f, id, props) {
    return f(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: props || {} }] })
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }

  function removeLine(f, key) { return changeQty(f, key, 0); }

  function changeQty(f, key, qty) {
    return f(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }

  function declined() {
    try { return (sessionStorage.getItem(OPTOUT) || "").split(",").filter(Boolean); }
    catch (e) { return []; }
  }
  function setDeclined(list) {
    try { sessionStorage.setItem(OPTOUT, list.filter(Boolean).join(",")); } catch (e) {}
  }
  function isDeclined(key) { return declined().indexOf(key) >= 0; }
  function decline(key) {
    var d = declined();
    if (d.indexOf(key) < 0) d.push(key);
    setDeclined(d);
  }
  function undecline() { setDeclined([]); }

  var REWARDS = {}, VARIANT_TO_KEY = {};
  CFG.tiers.forEach(function (t) {
    t.rewards.forEach(function (r) {
      REWARDS[r.key] = r;
      r.variants.forEach(function (v) { VARIANT_TO_KEY[v.id] = r.key; });
    });
  });

  function isReward(item) {
    return !!VARIANT_TO_KEY[item.variant_id] && !!(item.properties && item.properties._bd_kit);
  }

  /* --- sold-out kill switch (Nathan, 14 Aug 2026) ---------------------------
     If ANY reward variant is sold out — any size, any tier — the whole ladder
     stands down and the theme's native free-shipping bar takes over (removing
     bd-kit-on un-hides it; see bd-kit.css). A half-available ladder is worse
     than none: a sold-out sized reward would gate checkout on a size that
     can't be picked. The snippet bakes "merchOk" from live availability on
     every render; a mid-session sellout is caught by absorbQual re-reading
     each re-rendered config, and by any reward add coming back as an error.
     Reward lines already in the cart are removed so nothing sits there to be
     charged full price if the free-gift discount stops matching. */
  var KILL = "bdkit_kill", killed = false;
  function merchDead(cfg) { return !!cfg && cfg.merchOk === false; }
  function addFailed(res) {
    /* /cart/add.js error shape is {status:422,...}; success is {items:[...]}.
       A null res (challenge page, network blip) is NOT treated as sold out. */
    return !!(res && res.status && !res.items);
  }
  function die() {
    if (killed) return;
    killed = true;
    try { sessionStorage.setItem(KILL, "1"); } catch (e) {}
    try { mo.disconnect(); } catch (e) {}
    try { if (t) { clearTimeout(t); t = null; } } catch (e) {}
    document.querySelectorAll(".bd-kit").forEach(function (n) { n.remove(); });
    document.documentElement.classList.remove("bd-kit-on");
    document.documentElement.classList.remove("bd-kit-gate");
    cleanupRewards();
  }
  /* strip every reward line, as one queue job (the sold-out ladder kill: keep this behaviour) */
  function cleanupRewards() {
    Core.exclusive(function (f) {
      var removed = false;
      function step(depth) {
        return getCart(f).then(function (cart) {
          var line = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (isReward(cart.items[i])) { line = cart.items[i]; break; }
          }
          if (!line || depth >= 6) return { cart: cart, removed: removed };
          removed = true;
          return removeLine(f, line.key).then(function () { return step(depth + 1); });
        });
      }
      return step(0);
    }).then(function (res) {
      if (res && res.removed) { applyCartClasses(res.cart); refreshCartUI(); }
    }).catch(function () {});
  }
  /* Fresh Liquid is authoritative: a restock clears a kill left in the session
     by a failed add, so recovery needs no customer action beyond a page load. */
  try { if (!merchDead(CFG)) sessionStorage.removeItem(KILL); } catch (e) {}
  function isProtection(item) {
    return CFG.protectionHandle && item.handle === CFG.protectionHandle;
  }

  /* The drawer and the cart page each render their own #bd-kit-config with a
     "qualifying" {variant_id: bool} map (the unpublished qualifying collection is
     invisible to Liquid, so the snippet replicates its tag rule). Merge every map
     we can see; an unknown variant counts as NOT qualifying — under-counting is
     the safe direction. */
  var QUAL = {};
  /* The map also persists per-tab: a bfcache-restored page carries a config from
     before the cart changed, and an under-counted total here makes reconcile
     rip out a reward the customer legitimately earned. */
  try {
    (sessionStorage.getItem("bdkit_qual") || "").split(",").filter(Boolean).forEach(function (k) { QUAL[k] = true; });
  } catch (e) {}
  function absorbQual() {
    var deadCfg = false;
    document.querySelectorAll("#bd-kit-config").forEach(function (el) {
      try {
        var c = JSON.parse(el.textContent);
        if (merchDead(c)) deadCfg = true;
        var q = c.qualifying;
        if (q) Object.keys(q).forEach(function (k) { if (q[k]) QUAL[k] = true; });
      } catch (e) {}
    });
    try { sessionStorage.setItem("bdkit_qual", Object.keys(QUAL).join(",")); } catch (e) {}
    /* The drawer re-renders its config on every cart mutation, so a mid-session
       sellout shows up here within one sync. */
    if (deadCfg) die();
  }
  absorbQual();
  if (merchDead(CFG)) die();
  if (killed) return;

  function isQualifying(item) { return QUAL[item.variant_id] === true; }

  function qualifyingTotal(cart) {
    return cart.items.reduce(function (n, i) {
      return isReward(i) || isProtection(i) || !isQualifying(i) ? n : n + i.final_line_price;
    }, 0);
  }
  function shippingTotal(cart) {
    return cart.items.reduce(function (n, i) {
      return isReward(i) || isProtection(i) ? n : n + i.final_line_price;
    }, 0);
  }

  function rewardLine(cart, key) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isReward(it) && VARIANT_TO_KEY[it.variant_id] === key) return it;
    }
    return null;
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return "$" + v.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function stops() {
    var out = [];
    if (CFG.shipping && CFG.shipping.threshold > 0) {
      out.push({ kind: "ship", threshold: CFG.shipping.threshold, label: CFG.shipping.label || "Free shipping", rewards: [] });
    }
    CFG.tiers.forEach(function (t) {
      var label = t.rewards.map(function (r) { return r.short || r.title; }).join(" + ");
      out.push({ kind: "tier", threshold: t.threshold, label: label, rewards: t.rewards });
    });
    return out.sort(function (a, b) { return a.threshold - b.threshold; });
  }

  function evaluate(cart) {
    var qual = qualifyingTotal(cart),
      ship = shippingTotal(cart),
      all = stops();
    all.forEach(function (s) {
      s.total = s.kind === "ship" ? ship : qual;
      s.on = s.total >= s.threshold;
    });
    var next = null;
    all.forEach(function (s) { if (!s.on && !next) next = s; });
    var earned = [];
    CFG.tiers.forEach(function (t) {
      if (qual >= t.threshold) t.rewards.forEach(function (r) { earned.push(r); });
    });
    var pct = 100;
    for (var i = 0; i < all.length; i++) {
      if (!all[i].on) {
        var floor = i === 0 ? 0 : all[i - 1].threshold,
          span = all[i].threshold - floor,
          within = span > 0 ? (all[i].total - floor) / span : 0;
        pct = ((i + Math.max(0, Math.min(1, within))) / all.length) * 100;
        break;
      }
    }
    return { total: qual, ship: ship, stops: all, next: next, earned: earned, pct: pct };
  }

  /* what, if anything, the cart still owes the ladder: returns an action (run inside the queue job
     with the raw fetch) or null when the cart already matches the tier it has earned. Every action
     re-checks against the cart it was decided from, and the caller re-reads before deciding again. */
  function nextAction(cart, state) {
    var earnedKeys = state.earned.map(function (r) { return r.key; });
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isReward(it)) {
        var key = VARIANT_TO_KEY[it.variant_id];
        if (earnedKeys.indexOf(key) < 0) {            // orphan: reward line below its tier
          return (function (line) { return function (f) { return removeLine(f, line.key); }; })(it);
        }
        if (it.quantity > 1) {                        // a reward is always exactly one
          return (function (line) { return function (f) { return changeQty(f, line.key, 1); }; })(it);
        }
      }
    }
    /* two reward lines for the same reward (a double add): keep the first */
    var seenReward = {};
    for (var d = 0; d < cart.items.length; d++) {
      var di = cart.items[d];
      if (!isReward(di)) continue;
      var rk = VARIANT_TO_KEY[di.variant_id];
      if (seenReward[rk]) return (function (line) { return function (f) { return removeLine(f, line.key); }; })(di);
      seenReward[rk] = true;
    }
    if (addCount < 6) {
      for (var j = 0; j < state.earned.length; j++) {
        var r = state.earned[j];
        if (!r.sized && !isDeclined(r.key) && !rewardLine(cart, r.key)) {
          var v = r.variants.filter(function (x) { return x.available; })[0];
          if (v) {
            addCount++;
            return (function (variant, reward) {
              return function (f) {
                return addLine(f, variant.id, { _bd_kit: reward.key }).then(function (res) {
                  /* Config said available but Shopify refused the add: stand the ladder down. */
                  if (addFailed(res)) die();
                });
              };
            })(v, r);
          }
        }
      }
    }
    return null;
  }

  function build(cart, state) {
    var wrap = document.createElement("div");
    wrap.className = "bd-kit";
    if (CFG.accent) wrap.style.setProperty("--bd-accent", CFG.accent);
    var all = state.stops, pct = state.pct, msg;
    if (state.next) {
      var away = state.next.threshold - state.next.total;
      if (state.next.kind === "ship") {
        msg = "<b>" + money(away) + "</b> from free shipping";
      } else {
        var names = state.next.rewards.map(function (r) { return r.title; }).join(" + ");
        msg = "<b>" + money(away) + "</b> from free " + names;
      }
    } else {
      msg = "Free shipping and every reward unlocked.";
    }
    var pips = "", marks = "";
    all.forEach(function (st, i) {
      var on = st.on,
        left = ((i + 1) / all.length) * 100,
        last = i === all.length - 1;
      pips += '<span class="bd-kit__pip' + (on ? " is-on" : "") + '" style="left:' + left + '%"></span>';
      marks += '<span class="bd-kit__mark' + (on ? " is-on" : "") + (last ? " is-last" : "") + '" style="left:' + left + '%"><span class="bd-kit__amt">' + money(st.threshold) + '</span><span class="bd-kit__what">' + st.label + "</span></span>";
    });
    var rows = "";
    state.earned.forEach(function (r) {
      var line = rewardLine(cart, r.key);
      if (!(line && !changing[r.key]) && !isDeclined(r.key)) {
        var img = r.image ? '<img class="bd-kit__thumb" src="' + r.image + '" alt="" loading="lazy">' : '<span class="bd-kit__thumb"></span>';
        var needs = gateAttempted && r.sized && !line && !isDeclined(r.key);
        rows += '<div class="bd-kit__reward' + (line ? " is-changing" : "") + (needs ? " is-required" : "") + '" data-key="' + r.key + '">' + img + '<div><div class="bd-kit__rname">' + r.title + '</div><div class="bd-kit__rsub">' + (line ? "Pick a different size" : '<span class="bd-kit__ok">Unlocked</span> &mdash; pick your size<span class="bd-kit__req">*</span>') + '</div></div><div class="bd-kit__free">Free</div>' + (needs ? '<div class="bd-kit__err" role="alert">' + GATE_MSG + "</div>" : "") + sizeRow(r, line ? line.variant_id : null) + "</div>";
      }
    });
    var anyDeclined = state.earned.some(function (r) { return isDeclined(r.key); }),
      restore = anyDeclined ? '<button type="button" class="bd-kit__restore" data-act="restore">Changed your mind? Claim your free gear</button>' : "";
    wrap.innerHTML = '<div class="bd-kit__head"><div class="bd-kit__title">Bushdoof Rewards</div><div class="bd-kit__sub">' + msg + '</div></div><div class="bd-kit__rail"><span class="bd-kit__fill" style="width:' + pct + '%"></span>' + pips + '<span class="bd-kit__cap" style="left:clamp(9px,' + pct + '%,calc(100% - 9px))"></span></div><div class="bd-kit__marks">' + marks + "</div>" + (rows ? '<div class="bd-kit__rewards">' + rows + "</div>" : "") + restore;
    wrap.addEventListener("click", function (ev) {
      var btn = ev.target.closest("button");
      if (!btn) return;
      var act = btn.getAttribute("data-act");
      if (act === "restore") { undecline(); gateAttempted = false; syncNow(); return; }
      var key = btn.getAttribute("data-key");
      if (!key) return;
      if (act === "cancel") { changing[key] = false; lastSig = ""; syncNow(); return; }
      if (act === "decline") {
        decline(key);
        clearGateFor(key);
        document.querySelectorAll('.bd-kit__reward[data-key="' + key + '"]').forEach(function (rw) { rw.remove(); });
        lastSig = "";
        /* one queue job: re-read, remove the reward line if it is there. Idempotent. */
        Core.exclusive(function (f) {
          return getCart(f).then(function (cart) {
            var ln = rewardLine(cart, key);
            return ln ? removeLine(f, ln.key) : null;
          });
        }).then(function () { return syncNow(); }).then(function () { return refreshCartUI(); }, function () {});
        return;
      }
      if (act === "pick") {
        var vid = Number(btn.getAttribute("data-variant"));
        changing[key] = false;
        clearGateFor(key);
        document.querySelectorAll('.bd-kit__size[data-key="' + key + '"]').forEach(function (b) {
          b.classList.toggle("is-picked", Number(b.getAttribute("data-variant")) === vid);
        });
        /* remove-then-add as ONE queue job; skipped when that exact size is already the line */
        Core.exclusive(function (f) {
          return getCart(f).then(function (cart) {
            var current = rewardLine(cart, key);
            if (current && current.variant_id === vid) return null;
            var p = current ? removeLine(f, current.key) : Promise.resolve();
            return p.then(function () { return addLine(f, vid, { _bd_kit: key }); }).then(function (res) {
              if (addFailed(res)) die();
            });
          });
        }).then(function () { lastSig = ""; return syncNow(); }).then(function () { return refreshCartUI(); }, function () {});
      }
    });
    return wrap;
  }

  function sizeRow(r, pickedId) {
    var chips = r.variants.map(function (v) {
        var cls = "bd-kit__size" + (pickedId && v.id === pickedId ? " is-picked" : "");
        return '<button type="button" class="' + cls + '" data-act="pick" data-key="' + r.key + '" data-variant="' + v.id + '"' + (v.available ? "" : " disabled") + ">" + v.title + "</button>";
      }).join(""),
      outs = pickedId
        ? '<span class="bd-kit__outs"><button type="button" class="bd-kit__decline" data-act="cancel" data-key="' + r.key + '">Cancel</button><button type="button" class="bd-kit__decline" data-act="decline" data-key="' + r.key + '">Remove</button></span>'
        : '<span class="bd-kit__outs"><button type="button" class="bd-kit__decline" data-act="decline" data-key="' + r.key + '">No thanks</button></span>';
    return '<div class="bd-kit__sizes">' + chips + outs + "</div>";
  }

  var GATE_MSG = "Please select your free gift size or tap No thanks";
  var gateAttempted = false;
  var lastCart = null, lastState = null, t = null, syncP = null, syncAgain = false;

  function mount(cart, state) {
    if (!cart.items.filter(function (i) { return !isReward(i) && !isProtection(i); }).length) {
      document.querySelectorAll(".bd-kit").forEach(function (n) { n.remove(); });
      document.documentElement.classList.remove("bd-kit-on");
      document.documentElement.classList.remove("bd-kit-gate");
      return;
    }
    var hosts = [];
    document.querySelectorAll(".drawer__shipping-bar").forEach(function (b) {
      if (b.parentElement) hosts.push({ host: b.parentElement, before: b.nextSibling });
    });
    if (!hosts.length) {
      document.querySelectorAll('[name="checkout"]').forEach(function (b) {
        if (b.parentElement) hosts.push({ host: b.parentElement, before: b.parentElement.firstChild });
      });
    }
    document.documentElement.classList.add("bd-kit-on");
    var keep = [];
    hosts.forEach(function (h) {
      try {
        var node = build(cart, state);
        var existing = null;
        for (var c = h.host.firstChild; c; c = c.nextSibling) { if (c.classList && c.classList.contains("bd-kit")) { existing = c; break; } }
        if (existing) {
          /* same bar, new numbers: update in place so the rail animates and nothing flashes */
          if (existing.innerHTML !== node.innerHTML) {
            if (Core.morphInto) Core.morphInto(existing, node); else existing.innerHTML = node.innerHTML;
          }
          keep.push(existing);
          return;
        }
        if (h.before && h.before.parentNode === h.host) h.host.insertBefore(node, h.before);
        else h.host.appendChild(node);
        keep.push(node);
      } catch (e) { console.warn("bd-kit mount", e); }
    });
    document.querySelectorAll(".bd-kit").forEach(function (n) { if (keep.indexOf(n) < 0) n.remove(); });
    updateGate();
  }

  /* --- checkout gate: an unlocked sized reward must be picked or declined ---- */
  /* Sized rewards can't be auto-added (we don't know the size), so an unlocked one just sits in the
     bar waiting. Until every one is resolved - size picked or "No thanks" - EVERY way to checkout
     (Checkout + Protection, Checkout Without Protection, the plain button, View cart, the cart page)
     is intercepted: the drawer scrolls smoothly to the reward block and a red line says what to do.
     Express wallet buttons render inside iframes where a click can't be intercepted, so those are
     disabled by CSS via the bd-kit-gate class. */
  function pendingRewards() {
    if (killed || !lastCart || !lastState) return [];
    return lastState.earned.filter(function (r) {
      return r.sized && !isDeclined(r.key) && !rewardLine(lastCart, r.key);
    });
  }

  function updateGate() {
    var p = pendingRewards();
    document.documentElement.classList.toggle("bd-kit-gate", p.length > 0);
    if (!p.length) gateAttempted = false;
  }

  function clearGateFor(key) {
    document.querySelectorAll('.bd-kit__reward[data-key="' + key + '"]').forEach(function (row) {
      row.classList.remove("is-required");
      var e = row.querySelector(".bd-kit__err");
      if (e) e.remove();
    });
  }

  function scrollerOf(el) {
    for (var n = el.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === "auto" || oy === "scroll") && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return null;
  }
  function reducedMotion() {
    try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) { return false; }
  }

  function showGateError() {
    gateAttempted = true;
    var pend = pendingRewards().map(function (r) { return r.key; });
    document.querySelectorAll(".bd-kit__reward").forEach(function (row) {
      if (pend.indexOf(row.getAttribute("data-key")) < 0) return;
      row.classList.add("is-required");
      if (!row.querySelector(".bd-kit__err")) {
        var e = document.createElement("div");
        e.className = "bd-kit__err";
        e.setAttribute("role", "alert");
        e.textContent = GATE_MSG;
        /* above the size chips, so the message is on screen even when the block's lower edge is under the footer */
        var chips = row.querySelector(".bd-kit__sizes");
        if (chips) row.insertBefore(e, chips); else row.appendChild(e);
      }
    });
    var first = null;
    document.querySelectorAll(".bd-kit__reward.is-required").forEach(function (r) { if (!first && r.offsetParent !== null) first = r; });
    if (!first) return;
    var sc = scrollerOf(first), behavior = reducedMotion() ? "auto" : "smooth";
    if (sc) {
      /* scroll the DRAWER only (never the page behind it): put the reward block near the top, with its heading just above */
      var top = first.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 8;
      sc.scrollTo({ top: Math.max(0, top), behavior: behavior });
    } else if (first.scrollIntoView) {
      first.scrollIntoView({ block: "center", behavior: behavior });
    }
  }

  var GO_SEL = '[name="checkout"], .cart__checkout-button, .coverr__go, .coverr__skip, .cart__ctas a[href*="/cart"]';
  var allowOnce = false, gating = false;

  /* a fresh, settled cart: wait for every queued write and re-run the ladder once */
  function settle() {
    return Core.idle().then(function () { return killed ? null : syncNow(); });
  }
  function proceed(go) {
    allowOnce = true;
    try { go.click(); } finally { allowOnce = false; }
  }

  document.addEventListener("click", function (ev) {
    var go = ev.target.closest && ev.target.closest(GO_SEL);
    if (!go || allowOnce || go.disabled) return;
    var pend = pendingRewards();
    /* settled and clean: native behaviour, no delay */
    if (!pend.length && !Core.isBusy() && !syncP) return;
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
    if (pend.length) showGateError();
    if (gating) return;
    gating = true;
    go.setAttribute("aria-busy", "true");
    settle().then(function () {
      gating = false;
      go.removeAttribute("aria-busy");
      if (pendingRewards().length) { showGateError(); return; }
      proceed(go);
    }, function () { gating = false; go.removeAttribute("aria-busy"); });
  }, true);

  document.addEventListener("submit", function (ev) {
    if (allowOnce) return;
    var f = ev.target;
    if (!f || !/\/cart/.test(f.getAttribute("action") || "")) return;
    if (!pendingRewards().length && !Core.isBusy() && !syncP) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (pendingRewards().length) showGateError();
  }, true);

  /* Rows are found by the line-item KEY stamped on the remove button (stable no
     matter how lines shift), falling back to the positional row id only when the
     theme markup predates the data-key attribute. */
  function rowFor(item, idx) {
    try {
      var btn = document.querySelector('cart-remove-button[data-key="' + item.key + '"]');
      if (btn) {
        var row = btn.closest("tr, .cart-item");
        if (row) return row;
      }
      /* the key can be stale (a reward add/remove re-keys the other lines) and rows are GROUPS now, so the
         old "row number = line number" fallback would land on the wrong product. Match on variant id +
         the reward marker the row's group signature carries instead. */
      var rows = document.querySelectorAll('.cart-item[data-bd-key^="' + item.variant_id + '~"]');
      for (var k = 0; k < rows.length; k++) {
        if ((rows[k].getAttribute("data-bd-key") || "").indexOf("_bd_kit") >= 0) return rows[k];
      }
    } catch (e) {}
    return null;
  }

  /* a reward badge (and its hidden stepper) belongs only on a reward row: sweep any left on another row */
  function sweepBadges() {
    document.querySelectorAll(".bd-kit-line-badge").forEach(function (b) {
      var row = b.closest("tr, .cart-item");
      if (!row || (row.getAttribute("data-bd-key") || "").indexOf("_bd_kit") >= 0) return;
      var ch = row.querySelector(".bd-kit-line-change");
      if (ch) ch.remove();
      b.remove();
      var q = row.querySelector(".quantity, quantity-input");
      if (q) { q.style.removeProperty("display"); q.removeAttribute("data-bd-style"); }
    });
  }

  function decorate(cart) {
    sweepBadges();
    cart.items.forEach(function (item, idx) {
      if (!isReward(item)) return;
      var row = rowFor(item, idx);
      if (!row || row.querySelector(".bd-kit-line-badge")) return;
      var key = VARIANT_TO_KEY[item.variant_id],
        r = REWARDS[key],
        name = row.querySelector(".cart-item__name");
      if (name) {
        var b = document.createElement("span");
        b.className = "bd-kit-line-badge";
        b.textContent = "Free reward";
        name.parentNode.insertBefore(b, name.nextSibling);
        if (r && r.sized && r.variants.length > 1) {
          var c = document.createElement("button");
          c.type = "button";
          c.className = "bd-kit-line-change";
          c.setAttribute("data-bd-change", key);
          c.textContent = "Change size";
          name.parentNode.insertBefore(c, b.nextSibling);
        }
      }
      var q = row.querySelector(".quantity, quantity-input");
      if (q) { q.setAttribute("data-bd-style", ""); q.style.setProperty("display", "none", "important"); }
    });
  }

  var changing = {};
  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest && ev.target.closest("[data-bd-change]");
    if (!btn) return;
    ev.preventDefault();
    if (killed) return;
    changing[btn.getAttribute("data-bd-change")] = true;
    lastSig = "";
    syncNow().then(function () {
      var panel = document.querySelector(".bd-kit__reward.is-changing");
      var sc = panel && scrollerOf(panel);
      if (sc) sc.scrollTo({ top: Math.max(0, panel.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 8), behavior: reducedMotion() ? "auto" : "smooth" });
    });
  });

  /* re-render the theme's own drawer/cart-page rows from the server (morphs in place) */
  function refreshCartUI() {
    try {
      var drawer = document.querySelector("cart-drawer");
      var drawerReloaded = false;
      if (drawer && drawer.isInitialized && typeof drawer.reload == "function") { drawer.reload(); drawerReloaded = true; }
      document.querySelectorAll("cart-items, cart-drawer-items").forEach(function (items) {
        if (drawerReloaded && items.tagName === "CART-DRAWER-ITEMS") return;
        if (typeof items.onCartUpdate == "function") items.onCartUpdate();
      });
    } catch (e) { console.warn("bd-kit refresh", e); }
    return Core.idle();
  }

  function applyCartClasses(cart) {
    var empty = cart.item_count === 0;
    document.querySelectorAll("cart-drawer, cart-drawer-items, cart-items, #main-cart").forEach(function (el) {
      el.classList.toggle("is-empty", empty);
    });
  }

  /* True when a mount is owed. A theme refresh can replace ONE host (the /cart
     summary re-renders independently) while the drawer's bar survives off-canvas —
     "any .bd-kit exists" alone would skip that remount and leave the bare host
     with the checkout gate still armed and no visible size picker. So: missing if
     no bar exists while a host does, or if any shipping-bar host has lost its bar. */
  function barMissing() {
    if (!document.querySelector(".bd-kit")) {
      return !!(document.querySelector(".drawer__shipping-bar") || document.querySelector('[name="checkout"]'));
    }
    var miss = false;
    document.querySelectorAll(".drawer__shipping-bar").forEach(function (bar) {
      var host = bar.parentElement;
      if (host && !host.querySelector(".bd-kit")) miss = true;
    });
    return miss;
  }

  /* The whole ladder pass is ONE queue job: read the cart, decide, write, read again until the cart
     matches the tier it has earned. User writes (qty, remove, add) queue before/after it, never
     inside it, so nothing is ever decided from a stale cart. */
  function runLadder(f) {
    var mutated = false, n = 0;
    function loop() {
      return getCart(f).then(function (cart) {
        lastCart = cart;
        absorbQual();
        if (killed) return null;
        var state = evaluate(cart);
        lastState = state;
        var act = n++ < 6 ? nextAction(cart, state) : null;
        if (!act) return { cart: cart, state: state, mutated: mutated };
        mutated = true;
        return act(f).then(function () { return killed ? null : loop(); });
      });
    }
    return loop();
  }

  function sync() {
    if (killed) return Promise.resolve();
    if (syncP) { syncAgain = true; return syncP; }
    syncP = Core.exclusive(runLadder, "bdkit-ladder").then(function (res) {
      if (!res || killed) return;
      var cart = res.cart, state = res.state;
      applyCartClasses(cart);
      var sig = JSON.stringify([state.total, cart.items.map(function (i) { return i.variant_id + ":" + i.quantity; }), declined(), gateAttempted, changing]),
        changed = sig !== lastSig,
        missing = barMissing();
      if (changed) { lastSig = sig; addCount = 0; }
      try { mo.disconnect(); } catch (e) {}
      if (changed || missing) {
        try { mount(cart, state); } catch (e) { console.warn("bd-kit mount", e); }
      }
      try { decorate(cart); } catch (e) { console.warn("bd-kit decorate", e); }
      try { updateGate(); } catch (e) {}
      try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
      if (res.mutated) refreshCartUI();
    }).catch(function (e) {
      console.warn("bd-kit sync", e);
    }).then(function () {
      syncP = null;
      if (syncAgain) { syncAgain = false; schedule(); }
    });
    return syncP;
  }
  /* a pass that STARTS after now (waits out one already in flight) */
  function syncNow() {
    if (killed) return Promise.resolve();
    if (syncP) return syncP.then(function () { return syncNow2(); });
    return sync();
  }
  function syncNow2() { return syncP ? syncP : sync(); }

  function schedule() {
    if (killed) return;
    if (!t) t = setTimeout(function () { t = null; sync(); }, 120);
  }

  /* A theme re-render (drawer reload on add-to-cart, cart-items refresh) can destroy or skip the
     mounted bar. Re-mount synchronously from the cached cart/state so the bar is back in the same
     paint, then reconcile against the server in the background. */
  var mo = new MutationObserver(function () {
    if (killed) return;
    if (barMissing()) {
      if (lastCart && lastState) {
        try { mo.disconnect(); } catch (e) {}
        try { mount(lastCart, lastState); decorate(lastCart); } catch (e) { console.warn("bd-kit remount", e); }
        try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
      }
      if (!syncP) schedule();
    }
  });
  try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  if (document.readyState !== "loading") sync();
  else document.addEventListener("DOMContentLoaded", sync);

  ["cart:change", "cart:refresh", "cart:updated"].forEach(function (e) {
    document.addEventListener(e, schedule);
  });
  /* The theme announces every completed cart mutation on its pub-sub bus */
  try {
    if (typeof subscribe === "function" && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  } catch (e) {}
  document.addEventListener("click", function (ev) {
    if (ev.target.closest('[name="add"], .cart-item__remove, cart-remove-button')) schedule();
  }, true);
  window.addEventListener("pageshow", function (ev) {
    /* bfcache restore: the page is as it was left, the cart may not be. Re-render the cart page rows,
       drop the stale fingerprint so the bar re-mounts from fresh numbers, then reconcile. */
    if (ev.persisted) {
      lastSig = "";
      document.querySelectorAll("cart-items").forEach(function (items) {
        if (typeof items.onCartUpdate === "function") items.onCartUpdate();
      });
    }
    schedule();
  });
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") { lastSig = ""; schedule(); } });
})();
